/* eslint-disable import/prefer-default-export */
import queryString from 'query-string';
import { generatePath } from 'react-router-dom';

import { API_VERIONS_CREATIVES_URL, API_VERIONS_META_CREATIVES_URL } from '../../constants/apiUrls';
import { getRequestJSON } from '../../util/services';

export const getVersions = (
  apiHost: string,
  creativeId: number,
  targetedCreativeId: number,
  page: number,
  perPage: number,
  modelType: string = 'Creative',
  filters: Object = {}
): Promise<any> =>
  new Promise((resolve, reject) => {
    const queryParams = `?${queryString.stringify({
      ...filters,
      targeted_creative_id: targetedCreativeId ? targetedCreativeId.toString() : '',
      model_type: modelType.toString(),
      page: page + 1,
      per_page: perPage.toString(),
    })}`;
    const getVersionsAsyncHelper = async () => {
      const versions = await getRequestJSON(
        apiHost,
        generatePath(API_VERIONS_CREATIVES_URL, {
          creativeId: creativeId.toString(),
          '*': queryParams,
        }),
      );

      const meta = await getRequestJSON(
        apiHost,
        generatePath(API_VERIONS_META_CREATIVES_URL, {
          creativeId: creativeId.toString(),
          '*': `?${queryString.stringify({
            targeted_creative_id: targetedCreativeId ? targetedCreativeId.toString() : '',
            model_type: modelType.toString(),
          })}`,
        })
      );

      if (versions && meta) {
        resolve({
          ...versions,
          meta,
        });
      } else {
        reject();
      }
    };

    getVersionsAsyncHelper();
  });
